export default "__VITE_ASSET__909a69f6__"